import { connect } from "react-redux";
import { readSingleAppData } from "shared/redux-store/dataReaders";

import Welcome from "./WelcomeNew";

const mapStateToProps = state => {
  return {
    platformStatistics: readSingleAppData(state, "platformStatistics"),
  };
};

const mapDispatchToProps = () => {
  return {};
};

const WelcomeContainer = connect(mapStateToProps, mapDispatchToProps)(Welcome);

export default WelcomeContainer;
